import Vue from 'vue'
import Router from 'vue-router'
// import ComingSoon from '@/components/ComingSoon'
// import Article from '@/components/Article'
// import Events from '@/components/Events'
// import Event from '@/components/Event'
// import Login from '@/components/auth/Login'
// import Create from '@/components/cms/Create'
// import Test from '@/components/Test'
// import Home from '@/components/Home'

import AuthGuard from './auth-guard'

Vue.use(Router)

const Login = resolve => {
  require.ensure(['@/components/auth/Login'], () => {
    resolve(require('@/components/auth/Login'))
  })
}
const Create = resolve => {
  require.ensure(['@/components/cms/Create'], () => {
    resolve(require('@/components/cms/Create'))
  })
}
const Files = resolve => {
  require.ensure(['@/components/cms/Files'], () => {
    resolve(require('@/components/cms/Files'))
  })
}
const List = resolve => {
  require.ensure(['@/components/cms/List'], () => {
    resolve(require('@/components/cms/List'))
  })
}
const Edit = resolve => {
  require.ensure(['@/components/cms/Create'], () => {
    resolve(require('@/components/cms/Create'))
  })
}
const Projects = resolve => {
  require.ensure(['@/components/Projects'], () => {
    resolve(require('@/components/Projects'))
  })
}
const Views = resolve => {
  require.ensure(['@/components/Views'], () => {
    resolve(require('@/components/Views'))
  })
}
const Gartengestaltung = resolve => {
  require.ensure(['@/components/Gartengestaltung'], () => {
    resolve(require('@/components/Gartengestaltung'))
  })
}

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'maintenance',
    //   component: ComingSoon
    // },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/projekte',
      alias: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/jauschneg-admin',
      component: Login
    },
    {
      path: '/:niceUrl',
      props: true,
      component: Views
    },
    {
      path: '/projekte/:niceUrl',
      name: 'details',
      props: true,
      component: Views
    },
    {
      path: '/themen/gartengestaltung',
      name: 'gartengestaltung',
      props: true,
      component: Gartengestaltung
    },
    {
      path: '/themen/:niceUrl',
      name: 'themen',
      props: true,
      component: Views
    },
    {
      path: '/cms/list',
      component: List,
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/create',
      component: Create,
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/files',
      component: Files,
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/edit/:id',
      component: Edit,
      name: 'edit',
      props: true,
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js